import React from 'react';
import cls from 'classnames';

import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { FloatingSheetProps } from './FloatingSheet.types';
import { useSheet } from '../../../utilities/useSheet';
import ButtonStandard from '../../button/buttonStandard';

export const classNames = getClassNames('sds-floating-sheet', [
	'floating-sheet-overlay',
	'floating-sheet-container',
	'floating-sheet-content',
]);

const FloatingSheet: React.FC<FloatingSheetProps> = (props) => {
	const {
		onClose,
		className,
		toolbar,
		children,
		labelledBy,
		isDismissable = true,
	} = props;
	const { isClosing, closeSheet } = useSheet({ onClose, animationTimeout: 125 });

	return (
		<div
			className={cls(getRootClassListFromProps(classNames, props), className, {
				isClosing,
			})}
			// aria-hidden="true"
			aria-labelledby={labelledBy}
			role="dialog"
			data-testid={props['data-testid']}
		>
			{/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
			<div
				className={classNames.floatingSheetOverlay}
				onClick={isDismissable ? closeSheet : undefined}
			/>
			<div className={classNames.floatingSheetContainer} role="document">
				{toolbar}
				<div className={classNames.floatingSheetContent}>{children}</div>
			</div>
		</div>
	);
};

FloatingSheet.displayName = 'FloatingSheet';

export default FloatingSheet;
